export const FIELD = 'field';
export const FIELD_STUB = 'field-stub';
export const BLOCK = 'block';
export const BLOCK_STUB = 'block-stub';
export const FORMULA_TOKEN = 'formula-token';
